<template>
    <div class="w-2/5 min-h-4/5" id="ai-app-list">
        <div id="ai-app-list-text">Приложение</div>
        <dx-list
            id="ai-app-list-dx-list"
            ref="listRef"
            key-expr="kod_app"
            display-expr="name_app"
            selection-mode="single"
            :search-enabled="false"
            :data-source="appList"
            @item-click="onItemClick"
            :scroll-by-content="true"
            :scroll-by-thumb="true"
            show-scrollbar="always"
        >
            <template #item="{ data }">
                <div class="ai-app-list-item">
                    <component :is="data?.svg" class="ai-app-list-item-svg" />
                    <div>{{ data.name_app }}</div>
                </div>
            </template>
        </dx-list>
    </div>
</template>

<script>
export default {
    name: 'app-list',
};
</script>

<script setup>
import DxList from 'devextreme-vue/list';
import { inject, onMounted, ref } from 'vue';
import { getCookie, setCookie } from '@/utils/cookies';

const props = defineProps({
    appList: {
        type: Array,
        default: () => {
            return [];
        },
    },
});

const selectedApp = ref(new Map());

const listRef = ref(null);
const formData = inject('formData');

onMounted(async () => {
    const selectedAppFromCookie = getCookie('selectedApp');
    const currentLogin = getCookie('login');
    if (selectedAppFromCookie) {
        try {
            const selectedAppArray = JSON.parse(selectedAppFromCookie);
            selectedApp.value = new Map(selectedAppArray);
            if (selectedApp.value) {
                formData.appId = selectedApp.value.get(currentLogin);
                listRef.value.instance.selectItem(formData.appId);
            }
        } catch (error) {
            console.log(error);
        }
    }

    if (props.appList.length === 1) {
        formData.appId = props.appList[0].kod_app;
        selectedApp.value.set(currentLogin, formData.appId);
        setCookie('selectedApp', JSON.stringify(Array.from(selectedApp.value.entries())));
    }

    setTimeout(() => {
        const selectedItemIndex = props.appList.findIndex(el => el.kod_app === formData.appId);
        if (selectedItemIndex !== -1) {
            listRef.value.instance.selectItem(selectedItemIndex);
        }
    }, 100);
});
const onItemClick = event => {
    const currentLogin = getCookie('login');
    formData.appId = event.itemData.kod_app;

    selectedApp.value.set(currentLogin, formData.appId);
    setCookie('selectedApp', JSON.stringify(Array.from(selectedApp.value.entries())));
};
</script>

<style>
div:has(> .ai-depart-popup) {
    padding: 20px 0 !important;
    background-color: #f6fafe;
}

#ai-app-list-text {
    font-size: 24px;
    font-family: Golos, GolosText, sans-serif;
    padding-left: 30px;
}

.ai-app-list-item {
    display: flex;
    align-self: center;
    border-width: 4px;
    border-style: solid;
    border-color: #f6fafe;
    border-radius: 8px !important;
    background-color: rgba(0, 0, 0, 0.01);
}

.ai-app-list-item-svg {
    margin-right: 10px;
    fill: #286eb6;
    border-radius: 0 !important;
}

svg {
    border-radius: 0 !important;
}

.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item {
    background-color: #fff;
}

.dx-list-item-selected > .ai-app-list-item {
    background-color: #286eb6;
    color: #fff;
}

.dx-list-item-selected > .ai-app-list-item > .ai-app-list-item-svg {
    fill: #fff;
}

.ai-app-list-item :has(> .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-list-item-selected) {
    background-color: #000;
}

#ai-app-list-dx-list {
    padding-top: 10px;
    padding-left: 24px;
}
</style>